const getQyeryStrings = () => {
    const hash = window.location.hash;
    let query = {};
    if (hash.includes('?')) {
        const splitted = hash.split('?');
        const search = splitted.pop();
        query = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
    }
    return query;
};

export {getQyeryStrings}

